import TmoLogo from '../../assets/svg/tmo-logo.svg'
import ClearLogo from '../../assets/svg/clear-logo.svg';

const Header = () => {
  const isAuthenticated = true;

  return isAuthenticated === true ? (
    <header className="bg-secondary shadow">
      <nav className="mx-auto flex max-w-7xl items-center justify-between py-2 px-2 2xl:px-0">
        <div className="flex gap-1 sm:gap-2 items-center">
          <div className="flex bg-primary px-2 sm:px-3 py-1 sm:py-2">
            <img src={TmoLogo} alt="t-mo" className='w-4 sm:w-6' />
          </div>
          <p className="text-lg sm:text-[1.5rem] 2xl:text-[1.75rem] font-bold font-teleGroteskNextBold">Physical Access</p>
        </div>
      </nav>
    </header>
  ) : (<></>)
};

export default Header;
